export const baseURL = import.meta.env.VITE_BASE_URL;
